export default __webpack_public_path__ + "static/media/hero-uk-en.8c8948fc.gif";